// stripe.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TaxParams } from '../models/tax.model';

@Injectable({
  providedIn: 'root'
})
export class TaxService {

  constructor(private httpClient: HttpClient) {}

  computeTax(taxParams: TaxParams): Observable<number> {
    const apiUrl = `/onlinetesting/rest/eCommerce/getSalesTax`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Basic RG9uIE5ndXllbjpEbmd1eWVuMTk3Mg=='
    });

    const requestData = JSON.stringify(taxParams);

    return this.httpClient.post<number>(apiUrl, requestData, { headers: headers });
  }
}
